define(['app', 'underscore', 'jquery', './index.html'], function (
  app,
  _,
  $,
  tpl
) {
  'use strict'
  return app.Marionette.ItemView.extend({
    template: tpl,
    defaults: {
      isGuest: true,
      subscribedClass: 'is-active',
      loadingClass: 'is-loading',
      icon: ''
    },
    ui: {
      buttonText: '.text',
      loader: '.loader',
      icon: '.icon'
    },
    initialize: function () {
      var self = this

      self.$el.hide()
      if (!self.options.url || !_.isString(self.options.url)) {
        throw new Error('Provide a subscribe url')
      }
      self.options = _.extend({}, self.defaults, self.options)
      self.url = self.options.url
      self.isGuest = self.options.isGuest

      if (self.isGuest) {
        self.options.isSubscribed = false
      }

      if (!_.isUndefined(self.options.isSubscribed)) {
        self.isSubscribed = self.options.isSubscribed
      } else {
        $.get(self.url)
          .then(function () {
            self.isSubscribed = true
          })
          .fail(function () {
            self.isSubscribed = false
          })
          .always(function () {
            self.render()
          })
      }
    },
    render: function () {
      if (!_.isUndefined(this.isSubscribed)) {
        this.$el.html(this.template(this.options))
        this.bindUIElements()
        this.setSubscribed(this.isSubscribed)
        this.$el.show()
      }
      return this
    },
    subscribeUnsubscribe: function (e) {
      var self = this
      var action

      e.preventDefault()

      if (self.isLoading) {
        return
      }

      if (self.isGuest) {
        app.events.commands.execute('modal:login:show')
        return
      }

      self.setLoading(true)

      action = self.isSubscribed ? self.unsubscribe() : self.subscribe()

      action
        .then(function () {
          self.setSubscribed(!self.isSubscribed)
        })
        .always(function () {
          self.setLoading(false)
        })
    },
    subscribe: function () {
      return $.ajax({
        method: 'POST',
        url: this.url
      })
    },
    unsubscribe: function () {
      var self = this
      return $.get('/site/_tokens?name=unsubscribe').then(function (dataToken) {
        return $.ajax({
          method: 'DELETE',
          url: self.url,
          data: {
            _token: dataToken._token
          }
        })
      })
    },
    setLoading: function (isLoading) {
      if (isLoading) {
        this.isLoading = true
        this.$el.css('pointer-events', 'none')
        this.$el.addClass(this.options.loadingClass)
      } else {
        this.isLoading = false
        this.$el.css('pointer-events', 'auto')
        this.$el.removeClass(this.options.loadingClass)
      }
    },
    setSubscribed: function (isSubscribed) {
      if (isSubscribed) {
        this.isSubscribed = true
        this.$el.addClass(this.options.subscribedClass)
        this.ui.buttonText.text(this.options.strings.subscribed)
      } else {
        this.isSubscribed = false
        this.$el.removeClass(this.options.subscribedClass)
        this.ui.buttonText.text(this.options.strings.unsubscribed)
      }
    },
    events: {
      click: 'subscribeUnsubscribe'
    }
  })
})
